import getWhiteLabelStatus from './get-white-label-status';
import getUserFeatures from './get-user-features';
import isDeveloperMode from './is-developer-mode';
import getUserData from './get-user-data';

export default {
  getWhiteLabelStatus,
  getUserFeatures,
  isDeveloperMode,
  getUserData,
};
